import React, { Component } from 'react';

class WhiteContainer extends Component {
    render() {
        return (
            <div className="flex text-gray-600 overflow-x-auto white-container calculate-layout-button">
                <div className="w-full bg-white rounded-lg p-5 relative overflow-y-auto">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default WhiteContainer;